import { definePage } from "@openclaw/uirouter";
import { html } from "lit";

export const page = definePage({
  id: "projects",
  path: "/projects",
  component: () =>
    import("./projects-page.ts").then(() => ({
      header: true,
      render: () => html`<openclaw-projects-page></openclaw-projects-page>`,
    })),
});
